import { Link } from 'react-router-dom';
import { dailyContestArticles } from '@/mocks/articles';

export default function DailyContest() {
  return (
    <section className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="mb-8 md:mb-10">
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 leading-tight">
              每日大赛
              <br />
              精选爆料
            </h2>
            <p className="text-sm text-foreground-500 mt-2">编辑精选 · 不容错过的重磅猛料</p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {dailyContestArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group block"
              >
                <article className="rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-300 transition-all duration-300">
                  {/* Image */}
                  <div className="relative aspect-[3/4] overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                  </div>
                  {/* Content */}
                  <div className="p-5">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="text-xs px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 font-medium">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-500">{article.publishDate}</span>
                    </div>
                    <h3 className="text-base md:text-lg font-semibold font-heading text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/70">
                      <span className="text-xs text-foreground-500">
                        {article.author} · 报道
                      </span>
                      <span className="flex items-center gap-1 text-xs text-accent-600 font-semibold">
                        <i className="ri-fire-line w-3 h-3 flex items-center justify-center"></i>
                        {article.hotValue.toLocaleString()} 热度
                      </span>
                    </div>
                  </div>
                </article>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}